// extracted by extract-css-chunks-webpack-plugin
module.exports = {"productModelNumber":"Kc291"};